/**
 * cookie：cookie资源不能滥用，而且要被统一管理
 * 注意：整个项目的cookie都必须在此模块定义；只能使用本模块接口
 */
import Cookie from 'js-cookie';

// 白名单：可以使用的cookie名称
const WHITE_LIST = [
  'poi_m_web_csrf_token', // 防御跨站攻击
  'cdb_uid', // 用户ID
  'user_action_id',
  'last_poi_source',
  'source_client',
  'sa_referrer' // 对应 document.referrer；APP不支持 document.referrer
];

function warn(name) {
  if (process.env.NODE_ENV !== 'production') {
    if (WHITE_LIST.indexOf(name) === -1) {
      // eslint-disable-next-line
      console.warn(`警告：白名单没有该cookie(${name})`);
    }
  }
}

export function get(name) {
  warn(name);
  return Cookie.get(name);
}

export function set(name, value, options) {
  warn(name);
  return Cookie.set(name, value, options);
}
